// Environment Configuration Test
// This file helps verify that environment variables are properly configured

export const testEnvironmentConfig = () => {
    console.log('=== ENVIRONMENT CONFIGURATION TEST ===');

    // Check if REACT_APP_BACKEND_URL is set
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    if (!backendUrl) {
        console.error('❌ REACT_APP_BACKEND_URL is not set!');
        console.error('Please create a .env file with: REACT_APP_BACKEND_URL=http://your-backend-url/api/');
        return false;
    }

    console.log('✅ REACT_APP_BACKEND_URL is set:', backendUrl);

    // Test the specific attachment endpoints
    const signatureEndpoint = `${backendUrl}file/:userId/applicationsignature/:applicationId`;
    const attachmentsEndpoint = `${backendUrl}file/:userId/getAttachments/:applicationId`;

    console.log('📋 Signature API endpoint:', signatureEndpoint);
    console.log('📎 Attachments API endpoint:', attachmentsEndpoint);

    // Validate URL format
    if (!backendUrl.endsWith('/')) {
        console.warn('⚠️  Warning: REACT_APP_BACKEND_URL should end with a forward slash (/)');
    }

    if (!backendUrl.startsWith('http')) {
        console.warn('⚠️  Warning: REACT_APP_BACKEND_URL should start with http:// or https://');
    }

    console.log('=== END ENVIRONMENT TEST ===');
    return true;
};

// Auto-run the test when this module is imported
testEnvironmentConfig();
